import { useRouter } from 'next/router';

import { Box, FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyEditWebApiHandler_hidePhone } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { usePropertyEditMutation } from '../../../hooks/usePropertyEditMutation';

const inputName = 'hidePhone';

const AllowContactByPhoneFormField = ({ isRelistingFieldset }: { isRelistingFieldset?: boolean }) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);
  const initialHidePhone = listingDetails?.hidePhone ?? false;

  const updateMutation = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyEditWebApiHandler_hidePhone,
  });

  const hidePhoneField = useFieldSave({
    fieldName: inputName,
    initialValue: String(initialHidePhone),
    mutation: updateMutation,
    buildMutationVariables: (value) => ({
      getParams: { listingAlias, hidePhone: value === 'true' },
    }),
    autoSaveOnChange: true,
  });

  return (
    <div data-testid="AllowContactByPhoneFormField">
      <FieldSet
        legend={<Legend size={isRelistingFieldset ? 'lg' : 'md'}>Allow renters to contact you by phone</Legend>}
      >
        <Box css={{ display: 'flex', paddingLeft: '200', flexDirection: 'column' }}>
          <LabeledControl
            controlId="allow-phone-yes"
            label={
              <Label>
                Yes&nbsp;<strong>(Recommended)</strong>
              </Label>
            }
            control={
              <Radio
                name={inputName}
                value="false"
                checked={hidePhoneField.value === 'false'}
                onChange={(e) => hidePhoneField.onChange(e.target.value)}
              />
            }
          />
          <LabeledControl
            controlId="allow-phone-no"
            label={<Label>No</Label>}
            control={
              <Radio
                name={inputName}
                value="true"
                checked={hidePhoneField.value === 'true'}
                onChange={(e) => hidePhoneField.onChange(e.target.value)}
              />
            }
          />
        </Box>
      </FieldSet>
    </div>
  );
};

export default AllowContactByPhoneFormField;
